import {OrderedMap} from 'immutable';
import {mapValues} from 'lodash';

import catalog from './courseLibraryCatalog.json';

interface CourseLibraryPage {
  path: string;
  title: string;
  heading: string;
  metaDescription: string;
  breadcrumb: string;
}

interface CourseLibrarySubgroup extends CourseLibraryPage {
  subjects: Record<string, string>;
}

interface CourseLibraryGroup extends CourseLibraryPage {
  children: Record<string, CourseLibrarySubgroup>;
}

interface CourseLibraryDomain extends CourseLibraryPage {
  children: Record<string, CourseLibraryGroup>;
}

interface CourseLibraryCatalog extends CourseLibraryPage {
  children: Record<string, CourseLibraryDomain>;
  adaptivePractice: CourseLibraryPage;
}

const courseLibraryCatalog: CourseLibraryCatalog = catalog;

export const courseLibraryPages: readonly CourseLibraryPage[] = [
  courseLibraryCatalog,
  courseLibraryCatalog.adaptivePractice,
  ...Object.values(courseLibraryCatalog.children).flatMap((domain) => [
    domain,
    ...Object.values(domain.children).flatMap((group) => [group, ...Object.values(group.children)])
  ])
];

/** The menu's existing OrderedMap shape, derived from the catalog. */
export const courseLibraryStructure = OrderedMap(
  mapValues(courseLibraryCatalog.children, (domain) =>
    OrderedMap(
      mapValues(domain.children, (group) =>
        OrderedMap(mapValues(group.children, (subgroup) => OrderedMap(subgroup.subjects)))
      )
    )
  )
);
